export enum AppFeature {
    FrontEndAccess = "FrontEnd.Access",
    FrontEndUnsupportedBrowserPrompt = "FrontEnd.UnsupportedBrowserPrompt",

    Approval = "Approval",

    CaseManagement = "CaseManagement",
    CaseManagementSingleDownload = "CaseManagement.SingleDownload",
    CaseManagementExports = "CaseManagement.Exports",

    DeviceAudioSupport = "DeviceAccess.AudioSupport",
    CameraAccess = "DeviceAccess.Camera",
    IntercomAccess = "DeviceAccess.Intercom",

    LiveStreaming = "LiveStreaming",
    LiveStreamingAllowedLiveStreamFeedTypes = "LiveStreaming.AllowedLiveStreamFeedTypes",
    LiveStreamingSiteDetails = "LiveStreaming.SiteDetails",
    LiveStreamingSensitiveSiteDetails = "LiveStreaming.SensitiveSiteDetails",
    LiveStreamingStreamAnonymization = "LiveStreaming.StreamAnonymization",
    LiveStreamingIncidentFootage = "LiveStreaming.IncidentFootage",

    Playback = "Playback",
    PlaybackSingleDownload = "Playback.SingleDownload",

    SiteOperationsDingDong = "SiteOperations.DingDong",
    SiteOperationsKioskCheckIn = "SiteOperations.KioskCheckIn",
    SiteOperationsMuteAudio = "SiteOperations.MuteAudio",

    SiteOperationsDoors = "SiteOperations.Doors",
    SiteOperationsEmergency = "SiteOperations.Emergency",
    SiteOperationsClubLights = "SiteOperations.ClubLights",
    SiteOperationsAssist = "SiteOperations.Assist",
    SiteOperationsFireReset = "SiteOperations.FireReset",

    AdminDebugTools = "Admin.DebugTools",

    Diagnostics = "Diagnostics",

    Jobs = "Jobs",
}
